import { render, staticRenderFns } from "./AreaInformation.vue?vue&type=template&id=0ee87b9a&"
import script from "./AreaInformation.vue?vue&type=script&lang=ts&"
export * from "./AreaInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports